"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});


var utmSource = {
    wxpush: "oss",
    wx_dptuan: "oss" };

exports.default = utmSource;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/url-rewrite/dist/utm.js
// module id = 267
// module chunks = 0 9